import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=1ded2b92&scoped=true&"
import script from "./slideshow.vue?vue&type=script&lang=js&"
export * from "./slideshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded2b92",
  null
  
)

export default component.exports